<template>
  <el-popover
    v-if="qualities.length > 0"
    ref="popper"
    v-model="visible"
    placement="top"
    trigger="hover"
    :visible-arrow="false"
    :append-to-body="false"
    :popper-options="{ boundariesElement: '.file-viewer-video-wrapper' }"
    popper-class="file-viewer-video-resolution-popper"
  >
    <ul class="quality-list">
      <li
        v-for="quality in qualities"
        :key="quality.id"
        @click.stop.prevent="changeQuality(quality)"
      >
        <div
          class="quality-item"
          :class="{ active: quality.id === current.id }"
        >
          {{ quality.label }}
        </div>
      </li>
    </ul>
    <el-button v-if="current" slot="reference" class="popper-trigger">
      {{ current.selectedLabel }}
    </el-button>
  </el-popover>
</template>

<script>
export default {
  props: {
    qualities: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: null,
      visible: false
    }
  },
  created() {
    // 视频默认播放显示顺序
    const orders = Array.from(this.qualities).sort((a, b) => {
      return a.playIndex - b.playIndex
    })
    if (orders.length > 0) {
      this.changeQuality(orders[0])
    }
  },
  methods: {
    changeQuality(quality) {
      this.current = quality
      this.visible = false
      this.$emit('change', this.current)
    }
  }
}
</script>

<style lang="scss" scoped>
.popper-trigger {
  background-color: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  height: 24px;
  padding: 0 12px;
  border-radius: 12px;
  border: none;
  font-size: 13px;
  &:hover {
    background-color: #3352fe;
  }
}
.quality-list {
  background-color: #363636;
  width: 105px;
  padding: 8px 0;
  border-radius: 3px;
  .quality-item {
    padding: 12px 0;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
    font-size: 13px;
    &.active {
      font-size: 14px;
      color: #f8653f;
    }
  }
}
</style>

<style lang="scss">
.file-viewer-video-resolution-popper {
  padding: 0;
  border: none;
  min-width: 105px;
  box-shadow: none;
}
</style>
